import { Link } from "react-router-dom";

import { useOrderItems } from "@/hooks";

import { type OrderItemBreadcrumbProps } from "./OrderItemBreadcrumb.types";

export const OrderItemBreadcrumb = ({
  orderId,
  orderItemId,
  isOms,
}: OrderItemBreadcrumbProps) => {
  const { useGetOrderItem } = useOrderItems();
  const { data: orderItem, isPending } = useGetOrderItem({
    orderId,
    orderItemId,
  });

  if (isPending) {
    return;
  }
  return (
    <Link
      to={`/${isOms ? "oms/" : ""}orders/${orderId}/order-items/${orderItemId}`}
    >
      {orderItem?.data.orderItem.sandboxItem.name}
    </Link>
  );
};
